import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const Operation: RouteRecordRaw = {
  name: "运营优化",
  path: "/operation",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  redirect: "/operation/smart-strategy-manage",
  meta: {
    key: "/operation"
  },
  children: [
    {
      name: "智能策略管理",
      path: "smart-strategy-manage",
      meta: {
        key: "/operation/smart-strategy-manage"
      },
      component: () =>
        import("@/views/Operation/SmartStrategy/Manage/index.vue").catch(
          onError
        )
    },
    {
      name: "智能策略创建(AF点击告警)",
      path: "af-click-alerts",
      meta: {
        key: "/operation/af-click-alerts"
      },
      component: () =>
        import(
          "@/views/Operation/SmartStrategy/AFClickAlearts/index.vue"
        ).catch(onError)
    },
    {
      name: "智能策略创建(上量时序控制)",
      path: "mixture-tools",
      meta: {
        key: "/operation/mixture-tools"
      },
      component: () =>
        import("@/views/Operation/SmartStrategy/MixtureTools/index.vue").catch(
          onError
        )
    },
    /* {
      name: "智能策略详情",
      path: "smart-strategy-detail",
      meta: {
        key: "/operation/smart-strategy-detail"
      },
      component: () =>
        import("@/views/AutoRule/Detail/index.vue").catch(onError)
    }, */
    {
      name: "规则执行记录",
      path: "smart-strategy-log",
      meta: {
        key: "/operation/smart-strategy-log"
      },
      component: () =>
        import("@/views/Operation/SmartStrategy/Log/index.vue").catch(onError)
    },
    {
      name: "Offer定时启停",
      path: "offer-timed-task",
      meta: {
        key: "/operation/offer-timed-task"
      },
      component: () =>
        import("@/views/Operation/OfferTimedTask/TaskList.vue").catch(onError)
    },
    {
      name: "定时启停创建",
      path: "timed-task-create",
      meta: {
        key: "/operation/timed-task-create"
      },
      component: () =>
        import("@/views/Operation/OfferTimedTask/TaskCreate.vue").catch(onError)
    },
    {
      name: "流量组合配置面板",
      path: "source-tag-panel",
      meta: {
        key: "/operation/source-tag-panel"
      },
      component: () =>
        import("@/views/Operation/SourceTagPanel/index.vue").catch(onError)
    },
    {
      name: "PA报告",
      path: "pa-report",
      meta: {
        key: "/operation/pa-report"
      },
      component: () =>
        import("@/views/Operation/PaReport/index.vue").catch(onError)
    },
    {
      name: "线索管理",
      path: "clue-manage",
      meta: {
        key: "/operation/clue-manage"
      },
      component: () =>
        import("@/views/Operation/ClueManage/index.vue").catch(onError)
    },
    {
      name: "预算进度",
      path: "budget-progress",
      component: () =>
        import("@/views/Operation/BudgetProgress/index.vue").catch(onError),
      meta: {
        key: "/operation/budget-progress",
        keepAlive: true
      }
    }
  ]
};

export default Operation;
